'use strict';
import {createActions} from 'client/framework';

const normalActions = [
  'INITIALIZE_MENU_ITEMS',
  'SET_ACTIVE_SCHOOL_ID',
  'SET_ACTIVE_SCHOOL_LICENSE_ID',
  'SET_ACTIVE_USER_ID'
];

const schoolAdministrationActions = createActions(null, normalActions);
export default schoolAdministrationActions;
